module.exports = __webpack_public_path__ + "media/images/Small Shadow for Small White Box-bfec8585b296714222655966b2990bc2.svg";